import React, {useState} from "react";
import styles from "../photo/FJPhotoDetails.module.less";
import FJPureLoading from "../FJPureLoading";
import FJStockModalFooterView from "../FJStockModalFooterView";
import FJImage from "fj-components/FJImage";
import FJCoreUtil from "../../../../../core/util/FJCoreUtil";

function FJPhotoDetails(props) {
  const [loading, updateLoading] = useState(true);
  const [viewSize] = useState({width: 947, height: 529});
  const {onCancel, onSubmit, isAddToLibrary, url, thumbnail, title, id, originWidth, originHeight} = props;
  const _setImgLoadStatus = (status) => {
    updateLoading(status !== 'success')
  };
  const _onSubmit = () => {
    onSubmit(id, isAddToLibrary, url, {
      thumbnail,
      name: title,
      onSubmit: (hide) => {
        if (hide) {
          onCancel();
        }
      }
    })
  };
  let descMarginLeft = 0;
  let descMarginTop = 0;
  let descWidth = 'auto';
  if (originWidth || originHeight) {
    let size = FJCoreUtil.fitSize(viewSize, {width: originWidth, height: originHeight});
    descMarginLeft = (viewSize.width - size.width) / 2;
    descMarginTop = (viewSize.height - size.height) / 2;
    descWidth = viewSize.width - descMarginLeft * 2 - 26 * 2;
  }


  return (
    <div className={styles.item_container}>
      <div className={styles.photo_box}>
        <FJImage url={url} className={styles.photo} setImgLoadStatus={_setImgLoadStatus}/>
        <p style={{
          marginLeft: descMarginLeft,
          marginTop: descMarginTop,
          width: descWidth,
        }}
           className={styles.title}>
          {title}
        </p>
        <FJPureLoading active={loading}/>
      </div>
      <FJStockModalFooterView photoStyle
                              isAddToLibrary={isAddToLibrary}
                              onCancel={onCancel}
                              onSubmit={_onSubmit}
      />
    </div>
  )
}

export default FJPhotoDetails;